module.exports = __webpack_public_path__ + "assets/operate.7e1ea778.svg";